import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_onNavigateAction3fwn8i6kv096u as get_onNavigateAction } from './Link.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { NativeContainerElementWithSecondaryActionpxt1q8w6be21 as NativeContainerElementWithSecondaryAction } from '../InteractiveElement.mjs';
import { ClickableSemantic_getInstance29tidgppnw5x2 as ClickableSemantic_getInstance } from '../../models/Theme.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { get_mainPageNavigator26bf0rvtlvnco as get_mainPageNavigator } from '../../navigation/deprecated.mjs';
import { linkDriverActionsta8m06awp14l as linkDriverActions } from './DriverOverrides.mjs';
import { plus2m1vv33moko5t as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { Companion_instance3sky7m0l0l4tp as Companion_instance } from './Frame.commonHtml.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function Link$lambda$slambda(this$0, $it) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    var tmp0_safe_receiver = this$0.action_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.startAction_u0zgbm_k$($this$launch);
    }
    var tmp;
    // Inline function 'com.lightningkite.kiteui.views.direct.Link.newTab' call
    // Inline function 'com.lightningkite.kiteui.views.target' call
    var tmp_0 = this$0.native_1.attributes_1.native_1.target;
    if (((!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : null) === '_blank') {
      return Unit_instance;
    }
    $it.preventDefault();
    var tmp1_safe_receiver = this$0.to_1;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver();
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver_0 = get_onNavigateAction(this$0);
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        tmp0_safe_receiver_0.startAction_u0zgbm_k$($this$launch);
      }
      if (this$0.resetsStack_1) {
        this$0.onNavigator_1.reset_diztr_k$(tmp2_safe_receiver);
      } else {
        this$0.onNavigator_1.navigate_sm5lxf_k$(tmp2_safe_receiver);
      }
    }
    return Unit_instance;
  }), 1);
}
function Link$lambda$slambda_0(this$0, $it) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    var tmp0_safe_receiver = this$0.action_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.startAction_u0zgbm_k$($this$launch);
    }
    var tmp;
    // Inline function 'com.lightningkite.kiteui.views.direct.Link.newTab' call
    // Inline function 'com.lightningkite.kiteui.views.target' call
    var tmp_0 = this$0.native_1.attributes_1.native_1.target;
    if (((!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : null) === '_blank') {
      return Unit_instance;
    }
    $it.preventDefault();
    var tmp1_safe_receiver = this$0.to_1;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver();
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver_0 = get_onNavigateAction(this$0);
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        tmp0_safe_receiver_0.startAction_u0zgbm_k$($this$launch);
      }
      if (this$0.resetsStack_1) {
        this$0.onNavigator_1.reset_diztr_k$(tmp2_safe_receiver);
      } else {
        this$0.onNavigator_1.navigate_sm5lxf_k$(tmp2_safe_receiver);
      }
    }
    return Unit_instance;
  }), 1);
}
var LinkClass;
function Link() {
  if (LinkClass === VOID) {
    class $ extends NativeContainerElementWithSecondaryAction() {
      constructor(context) {
        super(context);
        this.set_themeChoice_py59um_k$(this.get_themeChoice_22tyn3_k$().plus_duvq05_k$(ClickableSemantic_getInstance()));
        this.native_1.tag_1 = 'a';
        this.native_1.classes_1.add_utx5q5_k$('kiteui-stack');
        this.native_1.classes_1.add_utx5q5_k$('clickable');
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_0 = this.native_1;
        var tmp0_safe_receiver = this_0.element_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          tmp0_safe_receiver.addEventListener('click', (it) => {
            launch(this, VOID, VOID, Link$lambda$slambda(this, it));
            return Unit_instance;
          });
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = this_0.eventsBack_1['on' + 'click'];
          var old = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
          var tmp_1 = 'on' + 'click';
          this_0.eventsBack_1[tmp_1] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            launch(this, VOID, VOID, Link$lambda$slambda_0(this, it));
            return Unit_instance;
          };
        }
        this.onNavigator_1 = get_mainPageNavigator(context);
        this.to_1 = null;
        this.resetsStack_1 = false;
      }
      get_driverActions_8jqr2k_k$() {
        return plus(super.get_driverActions_8jqr2k_k$(), linkDriverActions(this));
      }
      nativeSetAction_dc0jqw_k$(action) {
        var tmp = this.native_1;
        var tmp0_elvis_lhs = this.get_accessibleLabel_uztlo5_k$();
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          tmp_0 = action == null ? null : action.get_title_iz32un_k$();
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp.setAttribute_j9pxft_k$('aria-label', tmp_0);
      }
      nativeAddChild_hge4nv_k$(index, element) {
        super.nativeAddChild_hge4nv_k$(index, element);
        Companion_instance.internalAddChildStack_5el07d_k$(this, index, element);
      }
      set_to_opdqsp_k$(value) {
        this.to_1 = value;
        var tmp1_safe_receiver = value == null ? null : value();
        var tmp;
        if (tmp1_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp0_safe_receiver = this.onNavigator_1.get_routes_j3zccz_k$().render_y0xm4o_k$(tmp1_safe_receiver);
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            var tmp0 = this.native_1.attributes_1;
            // Inline function 'com.lightningkite.kiteui.views.href' call
            var value_0 = this.get_context_h02k06_k$().basePath_1 + tmp0_safe_receiver.urlLikePath_1.render_fgfjvu_k$();
            tmp0.native_1.href = value_0;
            tmp_0 = Unit_instance;
          }
          tmp = tmp_0;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          // Inline function 'com.lightningkite.kiteui.views.href' call
          this.native_1.attributes_1.native_1.href = '';
        }
      }
    }
    initMetadataForClass($, 'Link');
    LinkClass = $;
  }
  return LinkClass;
}
function Link$_get_secondaryAction_$ref_3ak2cs() {
  return constructCallableReference((p0) => p0.secondaryAction_1, 1, 0, 88);
}
function Link$_set_secondaryAction_$ref_a066jk() {
  return constructCallableReference((p0, p1) => {
    p0.set_secondaryAction_uet0qs_k$(p1);
    return Unit_instance;
  }, 2, 0, 89);
}
//region block: exports
export {
  Link as Link2eefk0yp041c4,
  Link$_get_secondaryAction_$ref_3ak2cs as Link$_get_secondaryAction_$ref_3ak2cs31jrfzz00hclc,
  Link$_set_secondaryAction_$ref_a066jk as Link$_set_secondaryAction_$ref_a066jk1f1nlfkc25u6x,
};
//endregion

//# sourceMappingURL=Link.commonHtml.mjs.map
